import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { Generator } from '../topic-widgets/generator';
import { TableAttrs } from 'book-widgets/interfaces';

import { TopicDetails } from '@holmescorp/lcc-state/interfaces';
import { ColSpecMap } from './table';
import { knownClasses } from './table-util';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

export interface TableBodyRowProperties {
	entries: TopicDetails[];
	rowAttrs?: TableAttrs;
	firstchild: boolean;
	widths: ColSpecMap;
}

const factory = create({ theme }).properties<TableBodyRowProperties>();

export const TableBodyRow = factory(({ properties, middleware: { theme } }) => {
	const { entries, rowAttrs = {} as TableAttrs, firstchild, widths } = properties();
	const themeCss = theme.classes(css);

	// check for skipped columns
	// Now that we're respecting rowspan, only need to account for the namest/nameend colspan
	const allEntries: (TopicDetails | null)[] = [];
	let idx: number = 0;
	entries.forEach((item) => {
		const { attributes = {} as TableAttrs } = (item as any).entry;
		const { colname, nameend } = attributes as TableAttrs;
		//		let targetCol;
		//		if (colname === undefined && namest === undefined) {
		//			targetCol = idx + 1;
		//		} else if (namest !== undefined) {
		//			targetCol = namest;
		//		} else {
		//			targetCol = colname!;
		//		}
		//		let thisCol = idx + 1;
		if (nameend !== undefined) {
			idx = +nameend;
		} else if (colname !== undefined) {
			idx = +colname;
		} else {
			idx += 1;
		}
		//		for (; thisCol < targetCol; ++thisCol) {
		//			allEntries.push(null);
		//		}
		allEntries.push(item);
	});

	const cols = allEntries.map((item, idx) => {
		if (item === null) {
			const styles = firstchild ? { width: `${widths.get('col-1')!.width}rem` } : {};
			return v('td', { styles });
		}
		const { attributes = {} as TableAttrs, children = [] } = (item as any).entry;
		const {
			outputclass,
			namest = 1,
			nameend = 1,
			morerows = 0,
			colsep,
			colname = idx + 1,
			align
		} = attributes as TableAttrs;
		const name = `col-${colname}`;
		const defaultColSep = widths.get(name)!.separator || null;
		const separator =
			colsep === undefined ? defaultColSep : colsep === 0 ? themeCss.noColumnSeparator : themeCss.columnSeparator;
		const colspan = namest !== nameend ? `${nameend - namest + 1}` : null;
		const rowspan = morerows > 0 ? `${morerows + 1}` : null;
		const styles = firstchild && colspan === null ? { width: `${widths.get(name)!.width}rem` } : {};
		const classes = outputclass && knownClasses.has(outputclass) ? [(themeCss as any)[outputclass]] : [];
		classes.push(separator);
		switch (align) {
			case 'left':
				classes.push(themeCss.alignLeft);
				break;

			case 'center':
				classes.push(themeCss.alignCenter);
				break;

			case 'right':
				classes.push(themeCss.alignRight);
				break;
		}

		return v('td', { classes, colspan, rowspan, styles }, [
			w(Generator, { topic: { attributes, children }, skipTitle: true, intable: true })
		]);
	});

	const { rowsep } = rowAttrs;
	const defaultRowSep = widths.get('tgroup')!.separator || null;
	const separator =
		rowsep === undefined ? defaultRowSep : rowsep === 0 ? themeCss.noRowSeparator : themeCss.rowSeparator;

	const classes = [separator];
	return v('tr', { classes }, cols);
});
